import React from "react";

const UserIcon = ({ className = "w-12 h-12", bgColor = "bg-gray-100", iconColor = "text-gray-400" }) => {
  return (
    <div className={`${className} ${bgColor} rounded-full flex items-center justify-center`}>
      <svg
        className={`w-2/3 h-2/3 ${iconColor}`}
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default UserIcon;